import * as stylex from '@stylexjs/stylex';
import { colors } from '@seeqdev/qomponents/colors.stylex';

/** Worksheet navigation is outside the print/PDF visualization surface. */
export const worksheetStyles = stylex.create({
  headerWatcherIcon: { fontSize: '1.5em' },
  pane: { height: '100%' },
  toolbar: {
    display: 'flex',
    flexDirection: 'row',
    flex: 'none',
    paddingLeft: '0.1875rem',
    justifyContent: 'space-between',
  },
  readOnlyToolbar: { justifyContent: 'flex-end' },
  filter: {
    display: 'flex',
    flexDirection: 'row',
    flex: 'none',
    justifyContent: 'space-between',
    paddingInline: '0.625rem',
  },
  scrollWrapper: { height: '100%', minHeight: 200, overflowY: 'auto', paddingBottom: 40, paddingTop: 10 },
  scrollArea: {
    height: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    marginRight: 1,
    overflowX: 'hidden',
    overflowY: 'auto',
    alignContent: 'flex-start',
    position: 'relative',
    gap: '0.625rem',
    paddingRight: '0.3125rem',
    paddingBottom: '1.25rem',
  },
  tile: { position: 'relative', paddingRight: '0.3125rem' },
  hidden: { display: 'none' },
  slide: { width: '6rem', marginLeft: 10 },
  labelRow: { display: 'flex', flexDirection: 'row', justifyContent: 'space-between' },
  editableLabelRow: { color: colors.bodyText },
  label: { flex: '1 1 auto', overflow: 'hidden', overflowWrap: 'break-word' },
  editableLabel: { paddingRight: '0.3125rem' },
  activeLabel: { color: colors.workbookPrimary },
  nameInput: { flex: '1 1 auto', overflow: 'hidden', marginBottom: 7 },
  labelActions: { display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' },
  mutedAction: { opacity: { 'default': 0.5, ':hover': 1 } },
  optionsIcon: { paddingInline: 1 },
  thumbnailLink: { cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center' },
  thumbnail: {
    backgroundColor: colors.background,
    borderRadius: 6,
    height: 80,
    width: 100,
    padding: '0.1875rem',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: colors.worksheetThumbnailBorder,
  },
  activeThumbnail: { borderWidth: '0.125rem', borderColor: colors.workbookPrimary },
  preview: { padding: '0.125rem' },
  previewImage: { backgroundColor: colors.background },
  draggableTile: { opacity: 1 },
  draggingTile: { opacity: 0.5 },
  watchers: { cursor: 'pointer', marginRight: '0.3125rem', whiteSpace: 'nowrap' },
  toolbarAction: { padding: '0.625rem' },
  addAction: { padding: '0.625rem', flexGrow: 1 },
  disabledAction: { opacity: 0.44, pointerEvents: 'none', cursor: 'inherit' },
  addIcon: { color: { 'default': colors.accent, ':hover': colors.icon } },
  addDocumentIcon: { width: 20 },
  activeAnalysisAction: { color: colors.worksheetAnalysisAction },
  activeTopicAction: { color: colors.worksheetTopicAction },
  activeBoardAction: { color: colors.worksheetBoardAction },
});
